var map = {
	"./Carousel_lang.js": [
		1515,
		515
	],
	"./Footer_lang.js": [
		5944,
		944
	],
	"./Navbar_lang.js": [
		2779,
		779
	],
	"./Topbar_lang.js": [
		1133,
		133
	],
	"./about/about_body_lang.js": [
		7041,
		41
	],
	"./contact/contact_lang.js": [
		3274,
		274
	],
	"./contact/error_return_lang.js": [
		777,
		777
	],
	"./feature/feature_body_lang.js": [
		5785,
		785
	],
	"./home/home_About_lang.js": [
		2316
	],
	"./home/home_Carousel_lang.js": [
		5379,
		379
	],
	"./home/home_CoreFeatures_lang.js": [
		5397,
		397
	],
	"./home/home_Gallery_lang.js": [
		137,
		137
	],
	"./home/home_Kpi_lang.js": [
		6705,
		705
	],
	"./home/home_Outsourcing_lang.js": [
		7865,
		865
	],
	"./home/home_Partners_lang.js": [
		156,
		156
	],
	"./home/home_PricingCard_lang.js": [
		1367,
		367
	],
	"./home/home_PricingComparison_lang.js": [
		2694,
		694
	],
	"./home/home_PricingPlans_lang.js": [
		1035,
		35
	],
	"./home/home_SecurityFeatures_lang.js": [
		398,
		398
	],
	"./home/home_Services_lang.js": [
		7281,
		281
	],
	"./home/home_SolutionSection_lang.js": [
		5021,
		21
	],
	"./home/home_StrategyGenie_lang.js": [
		3226,
		226
	],
	"./outsourcing/outsourcing_lang.js": [
		4898,
		898
	],
	"./partner/partner_body_lang.js": [
		1885,
		885
	],
	"./product/product_ai_lang.js": [
		5623,
		623
	],
	"./product/product_ai_projects2_lang.js": [
		4322,
		322
	],
	"./product/product_ai_projects_lang.js": [
		8360,
		360
	],
	"./product/product_ai_video_lang.js": [
		9963,
		963
	],
	"./product_lib/product_download_lang.js": [
		6689,
		689
	],
	"./product_lib/product_lib_intro_lang.js": [
		7365,
		365
	],
	"./product_lib/product_lib_lang.js": [
		5130,
		130
	],
	"./product_lib/product_report_lang.js": [
		9447,
		447
	],
	"./service/service_body_lang.js": [
		49,
		49
	],
	"./team/team_body_lang.js": [
		6217,
		217
	],
	"./terms/api_body_lang.js": [
		7330,
		330
	],
	"./terms/disclaimer_body_lang.js": [
		3707,
		707
	],
	"./terms/payment_body_lang.js": [
		3488,
		107
	],
	"./terms/platform_body_lang.js": [
		1171,
		171
	],
	"./terms/privacy_body_lang.js": [
		3514,
		514
	],
	"./video/video_body_lang.js": [
		7785,
		166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2991;
module.exports = webpackAsyncContext;